import {RoomState} from '../../../../../shared/RoomState'
import {createOptionIn, updateSelectElement} from '../../../../shared/scripts/ui_utils/DomUtils'
import {SocketLobbySend} from '../../../../shared/scripts/socket/SocketLobbySend'
import {StorageWrapper} from '../../../../shared/scripts/StorageWrapper'
import {socket} from '../../../../shared/scripts/EntryShared'
import {DiceSettingEnum, RoomSettingConstants} from '@colonist/game-base-types'

export class UIRoomCenterSettingsDiceController {
    private readonly selectElement: HTMLSelectElement
    private readonly divElement: HTMLDivElement

    constructor() {
        this.selectElement = document.getElementById('room_center_select_dice') as HTMLSelectElement
        this.divElement = document.getElementById('room_center_dice_settings') as HTMLDivElement
    }

    update(newRoomState: RoomState) {
        updateSelectElement(this.selectElement, DiceSettingEnum[newRoomState.gameSetting.diceSetting])

        this.divElement.className = this.selectElement.value == DiceSettingEnum[RoomSettingConstants.DEFAULT_DICE_SETTING].toString() ?
            'room_option_item deselected' : 'room_option_item selected'
    }

    load(roomState: RoomState) {
        this.updateElement(roomState)
    }

    private updateElement(roomState: RoomState) {
        const className = !roomState.isHost(socket.controller.session.id) ? 'room-room_center_select room_center_select_disable' : 'room_center_select-select'
        this.selectElement.className = className
        this.selectElement.onchange = () => {
            const diceSetting = this.selectElement.value
            if(diceSetting === 'Random') StorageWrapper.setRoomDiceSetting(DiceSettingEnum.Random)
            if(diceSetting === 'Balanced') StorageWrapper.setRoomDiceSetting(DiceSettingEnum.Balanced)

            SocketLobbySend.clickedRoomSettingUpdateDiceSetting(this.selectElement.value)
        }

        this.selectElement.options.length = 0

        createOptionIn(this.selectElement, String(DiceSettingEnum[DiceSettingEnum.Random]), {key: `strings:colonistCommon.DiceSettingEnum.Random`})
        createOptionIn(this.selectElement, String(DiceSettingEnum[DiceSettingEnum.Balanced]), {key: `strings:colonistCommon.DiceSettingEnum.Balanced`})
    }

    updateInteractabilityOfElements(isGuest: boolean) {
        this.selectElement.disabled = isGuest
    }
}
